'use strict';

wbApp.factory('emailTemplatesSvc', ['$resource', '$translate', '$q', 'notificationSvc', 'repositorySvc',
    function ($resource, $translate, $q, notificationSvc, repositorySvc) {

        var EmailTemplates = $resource('/restapi/email-templates', {}, {
            'getAllInfo': { method: 'GET', url: '/restapi/email-templates/info', isArray: true },
            'getById': { method: 'GET', url: '/restapi/email-templates/:id' },
            'update': { method: 'PUT', url: '/restapi/email-templates/:id' },
            'delete': { method: 'DELETE', url: '/restapi/email-templates/:id' },
            'preview': { method: 'POST', url: '/restapi/email-templates/preview' },
        });

        var allInfos;

        function getAllInfo(localeAlias, reload) {
            if (!allInfos || reload) {
                allInfos = repositorySvc.customGet('getAllInfo', EmailTemplates, {
                    localeAlias: localeAlias || 'CS'
                });
            }

            return allInfos;

        }

        function getInfoById(documentTemplateType, emailCategory, localeAlias) {

            return $q(function (resolve, reject) {
                var infos = getAllInfo(localeAlias);
                infos.$promise.then(function (data) {
                    resolve(_.find(data, { 'documentTemplateType': documentTemplateType, 'emailCategory': emailCategory }));
                }, reject);
            });
        }

        function getById(documentTemplateType, emailCategory, localeAlias) {
            return repositorySvc.customGet('getById', EmailTemplates, {
                id: documentTemplateType,
                emailCategory: emailCategory,
                localeAlias: localeAlias || 'CS'
            });
        }

        function update(model) {
            return repositorySvc.customPutWithParams(
                'update',
                EmailTemplates,
                {
                    id: model.documentTemplateType,
                    emailCategory: model.emailCategory,
                    localeAlias: model.localeAlias
                },
                model);
        }

        function preview(model) {
            return repositorySvc.customPost(
                'preview',
                EmailTemplates,
                model,
                null /* successCallback */,
                null /* errorCallback */,
                true /* doNotShowSuccessNotification */);
        }


        function remove(documentTemplateType, emailCategory, localeAlias) {
            return repositorySvc.customDelete(
                'delete',
                EmailTemplates,
                {
                    id: documentTemplateType,
                    emailCategory: emailCategory,
                    localeAlias: localeAlias || 'CS'
                });
        }

        return {
            getAllInfo: getAllInfo,
            getById: getById,
            update: update,
            remove: remove,
            preview: preview,
            getInfoById: getInfoById
        }
    }]);